export const initialStateLoading = {
  isLoading: true,
  isFormLoading: false,
  isHidden: false
}

export function reducer(state, action) {
  switch (action.type) {
    case 'FINISHED_LOADING':
      return {
        ...state,
        isLoading: false
      }
    case 'FINISHED_FORM_LOADING':
      return {
        ...state,
        isFormLoading: false
      }
    case 'SUGGESTION_REQUEST':
      return {
        ...state,
        isHidden: true
      }

    default:
      return state
  }
}
